import script from "./SetupCompleteStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./SetupCompleteStep.vue?vue&type=script&setup=true&lang=ts"

import "./SetupCompleteStep.vue?vue&type=style&index=0&id=571f4d91&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-571f4d91"]])

export default __exports__